export const lastLinkSource = {
  AI_SYNC: "kaisync",
  AI_IMPORT: "kaiimport"
};

export const custodianOrigin = {
  WEB_SYNC: "web_sync",
  AI_IMPORT: "ai_import"
};

const lastLinkSourceToCustodianOrigin = {
  [lastLinkSource.AI_SYNC]: custodianOrigin.WEB_SYNC,
  [lastLinkSource.AI_IMPORT]: custodianOrigin.AI_IMPORT
};

// custodian origin sent on create: JSON {t: type, s: institution, u: Kubera userId}.
// Undefined for anything that isn't Web Sync / AI import, so a normal UI create sends none.
export const buildCustodianOrigin = (lastLinkMetadata, userId) => {
  const { source, institution } = lastLinkMetadata || {};
  const type = lastLinkSourceToCustodianOrigin[source];
  if (!type) {
    return undefined;
  }
  return JSON.stringify({ t: type, s: institution || undefined, u: userId || undefined });
};

export const getCustodianOriginWallet = origin => {
  if (typeof origin !== "string" || origin.trim().length === 0) {
    return null;
  }
  try {
    const { c: chain, a: address } = JSON.parse(origin) || {};
    if (typeof address !== "string" || !address) {
      return null;
    }
    return { chain: typeof chain === "string" ? chain : "", address };
  } catch (e) {
    return null;
  }
};

export const isAiSyncLastLink = lastLink => typeof lastLink === "string" && lastLink.includes(lastLinkSource.AI_SYNC);

export const parseLastLink = lastLink => {
  if (typeof lastLink !== "string" || lastLink.trim().length === 0) {
    return null;
  }
  try {
    const parsed = JSON.parse(lastLink);
    if (parsed && typeof parsed === "object" && !Array.isArray(parsed)) {
      return parsed;
    }
    return null;
  } catch (e) {
    console.log("lastLink parse error:", e);
    return null;
  }
};

export const getParsedLastLinkNames = parsedLastLink =>
  Array.isArray(parsedLastLink?.name) ? parsedLastLink.name : [];

export const getLastLinkNames = lastLink => getParsedLastLinkNames(parseLastLink(lastLink));

export const isAiImportLastLink = (lastLink, linkType) => {
  if (typeof lastLink !== "string" || lastLink.trim().length === 0) {
    return false;
  }
  const parsed = parseLastLink(lastLink);
  if (parsed) {
    return parsed.source === lastLinkSource.AI_IMPORT;
  }
  if (lastLink.includes(lastLinkSource.AI_IMPORT)) {
    return true;
  }
  if (lastLink.includes(lastLinkSource.AI_SYNC)) {
    return false;
  }
  return !linkType;
};
